import { ACTIONS_INSALES } from '../actions/insales';

export const insales = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_INSALES.ADD_PRODUCTS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_INSALES.CHANGE_PRODUCT: {
      const { product } = action;
      return { ...state, byId: { ...state.byId, [product.id]: { ...product } } };
    }
    case ACTIONS_INSALES.CHANGE_MARKET: {
      const { market } = action;
      return { ...state, market };
    }
    default:
      return state;
  }
};
